import React, { useContext } from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import { NotificationsStoreContext } from '../../../ui/notifications-context';
import { useFetchMessagesByLocale } from './locales';
var NotificationIntlProvider = function NotificationIntlProvider(_ref) {
  var children = _ref.children;
  var intl = useIntl();
  var _useFetchMessagesByLo = useFetchMessagesByLocale(intl.locale),
    messages = _useFetchMessagesByLo.messages,
    isReady = _useFetchMessagesByLo.isReady;
  var _useContext = useContext(NotificationsStoreContext),
    updateIntlLocale = _useContext.updateIntlLocale;

  /**
   * Blocks rendering until i18n is ready to prevent
   * briefly showing default EN locale before
   * rendering correct locale
   */
  if (!isReady) {
    return null;
  }
  updateIntlLocale(intl.locale);
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: messages,
    locale: intl.locale
  }, children);
};
export default NotificationIntlProvider;